import React from "react";

const AccountingBookIcon = (props) => {
  let height = props?.height ? props?.height : 20;
  let width = props?.width ? props?.width : 20;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      x="0"
      y="0"
      viewBox="0 0 32 32"
      class=""
    >
      <g>
        <path
          d="M13 24V12c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2zm-7.79-1.5h-.44c-.55 0-1-.45-1-1s.45-1 1-1h.44c.55 0 1 .45 1 1s-.45 1-1 1zm0-3h-.44c-.55 0-1-.45-1-1s.45-1 1-1h.44c.55 0 1 .45 1 1s-.45 1-1 1zm3.56 3h-.44c-.55 0-1-.45-1-1s.45-1 1-1h.44c.55 0 1 .45 1 1s-.45 1-1 1zm0-3h-.44c-.55 0-1-.45-1-1s.45-1 1-1h.44c.55 0 1 .45 1 1s-.45 1-1 1zm0-4h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1zM24.5 8h5.91L24 1.59V7.5c0 .28.22.5.5.5z"
          fill="currentColor"
          opacity="1"
          data-original="#000000"
          class=""
        ></path>
        <path
          d="M24.5 10A2.5 2.5 0 0 1 22 7.5V1H9.5A2.5 2.5 0 0 0 7 3.5V8h4.23c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4H7v.5A2.5 2.5 0 0 0 9.5 31h19a2.5 2.5 0 0 0 2.5-2.5V10zM12 5c-.55 0-1-.45-1-1s.45-1 1-1h7c.55 0 1 .45 1 1s-.45 1-1 1zm3 3c0-.55.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1h-3c-.55 0-1-.45-1-1zm12 19H17c-.55 0-1-.45-1-1s.45-1 1-1h.5v-4c0-.55.45-1 1-1s1 .45 1 1v4H21v-8c0-.55.45-1 1-1s1 .45 1 1v8h1.5V13c0-.55.45-1 1-1s1 .45 1 1v12h.5c.55 0 1 .45 1 1s-.45 1-1 1z"
          fill="currentColor"
          opacity="1"
          data-original="#000000"
          class=""
        ></path>
      </g>
    </svg>
  );
};

export default AccountingBookIcon;
